import type { ReactNode } from 'react';
import { css } from '@linaria/atomic';
import { Icon, type IconName } from '@frontend/icons';
import { Button } from '@frontend/design-system';

const styles = {
  card: css`
    min-height: 84px;
    padding: var(--fabric-space-padding-md);
    text-transform: none;

    & > span {
      align-items: center;
      flex-direction: column;
      gap: var(--fabric-space-gap-xs);
      justify-content: center;
      text-align: center;
      white-space: normal;
    }
  `,
};

type CareCreditMethodCardProps = {
  iconName: IconName;
  label: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  disabledTooltip?: ReactNode;
};

export const CareCreditMethodCard = ({
  iconName,
  label,
  onClick,
  disabled = false,
  disabledTooltip,
}: CareCreditMethodCardProps) => {
  return (
    <Button
      variant='secondary'
      className={styles.card}
      onClick={onClick}
      disabled={disabled}
      hoverLabel={disabledTooltip}
      hoverLabelPlacement='top'
      showLabelWhenDisabled
    >
      <Icon name={iconName} size={24} color={disabled ? 'disabled' : 'default'} />
      {label}
    </Button>
  );
};

export const careCreditMethodCards = css`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--fabric-space-gap-md);

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;
